import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
/*
  Volume Slider
  
  Changes the current volume of the playing media.
*/
export default class VolumeSlider extends React.Component{
    constructor(props){
        super(props);
        this.state = {
        	isDraggable: false
        }
        this.ControlsActions = props.ControlsStore.ControlsActions;
    }
    shouldComponentUpdate(nextProps, nextState){
        return false;
    }
    componentDidMount() {
      const eventName = `mouseup.VideoVolumeSlider-${this.props.video}`;
    	$(document).off(eventName).on(eventName,(e)=>{
     		this.setState({
    			isDraggable: false
    		})
    	})
    }
    componentWillUnmount(){
      const eventName = `mouseup.VideoVolumeSlider-${this.props.video}`;
      $(document).off(eventName);
    }
    doDrag(e){
    	if(!this.state.isDraggable) return;
  		let $this = $(ReactDOM.findDOMNode(this));
  		let cursorPageY = e.nativeEvent.pageY;
  		let $dragEl = $(this.dragEl);
  		let $volumeEl = $this.find('.volume');
  		let thisTop = $this.offset().top;
  		let volumeTop = $volumeEl.offset().top;
  		let volumeHeight = $volumeEl.height();
  		let dragElHeight = $dragEl.height();
  		let offsetTop = cursorPageY - volumeTop - (dragElHeight/2);
  		let volume = 1 - (offsetTop/volumeHeight);
  		if(volume>1){
  			volume=1;
  		}
  		else if(volume<0){
  			volume=0;
  		}
  		this.ControlsActions.changeVolume(volume);

    }
    render() {
      const VolumeSliderProps = {
        className: cx({
          'volume-bar-wrap': true
        }),
        onMouseMove: (e)=>{
          this.doDrag(e);
        }
      }
  		const DragButtonProps = {
        ControlsStore: this.props.ControlsStore,
  			onDraggable: (e) =>{
  				e.preventDefault();
  				this.dragEl = e.target;
  				this.state.isDraggable = true;
  			}
  		}

      return (
        <div {...VolumeSliderProps}>
  				<div className="volume-bar">
  				    <div className="volume-inner">
  				    	<div className="not-volume"></div>
  				    	<div className="volume">
  				    		<VolumeDragButton {...DragButtonProps } />
  				    	</div>
  				    </div>
  				</div>
        </div>
      )
    }
}

VolumeSlider.propTypes={
  ControlsStore: React.PropTypes.object
}
VolumeSlider.defaultProps={
}
class VolumeDragButton extends Reflux.Component{
  	constructor(props){
  		super(props)
  		this.state = {}
  		this.store = props.ControlsStore;
  	}
    componentDidMount() {
    	//let $this = $(ReactDOM.findDOMNode(this));
     }
    shouldComponentUpdate(nextProps, nextState){
        return nextState.volume!=this.state.volume;
    }
    componentWillUpdate(nextProps, nextState){
    }

	render(){
		let topPos = (1-this.state.volume)*100;
		let volumeDragProps = {
			className: "volume-drag",
			style: {
				top: topPos+'%'
			},
			onMouseDown: (e)=>{
				this.props.onDraggable(e)
			},
      onClick: (e)=>{
        e.preventDefault();
        e.stopPropagation();
      }
  	}
		return(
			<div {...volumeDragProps}></div>
		)

	}
}
VolumeDragButton.propTypes={
  ControlsStore: React.PropTypes.object.isRequired,
	onDraggable: React.PropTypes.func.isRequired
}
VolumeDragButton.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/video/player-controls/volume-slider.jsx